<template>
  <div>
    <modal
      class="confirmation-modal"
      width="600px"
      height="100px"
      :value="showModal"
      effect="fade"
      @closed="closed"
      large
    >
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">
          <strong>{{ textTitle }}</strong>
        </h4>
      </div>
      <div
        class="modal-body file-download-modal-body"
        style="height: 150px; padding: 5px 15px; overflow-x: auto"
      >
        <center>
          <span v-html="textMessage"></span>
          <br>
          <br>
          <span
            v-show="spinVisable"
            style="font-size: 30px;color: #5b9bd5;"
            class="glyphicon glyphicon-repeat glyphicon-spin"
          ></span>
        </center>
        <!-- FILE_EXPORT_PART2 : Step 19 -->
        <a :href="linkToOpen" :target="'open_file'+linkToOpen" ref="open_file" v-show="false">#</a>
      </div>
      <div slot="modal-footer" class="modal-footer" style="display: none;">
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from "vue";
import { bus } from "@/libs/bus";
import { utils } from "@/libs/utils";
var vm = this;

import modal from "./local-modal";
Vue.component("modal", modal);

import debug from "debug";
var debug_msg = debug("esma:file-download-modal");

export default {
  data() {
    return {
      show_modal: false,

      title_label: "title",
      message: "msg",
      yes_label: "",
      no_label: "",
      callback: null,
      show_large: false,
      link_to_open:"#",
      spin_visable:true,
      sub_search:false,
      api_request_options:false
    };
  },
  computed: {
    spinVisable:{
      get(){
        return this.spin_visable;
      },
      set(v){
        this.spin_visable = v;
      }
    },
    linkToOpen:{
      get(){
        return this.link_to_open;
      },
      set(v){
        this.link_to_open = v;
      }
    },
    showLarge: {
      get() {
        return this.show_large;
      },
      set(v) {
        this.show_large = v;
      },
    },
    getTrue() {
      return true;
    },
    getFalse() {
      return false;
    },
    textTitle() {
      return this.title_label;
    },
    // textYes() {
    //   return this.yes_label || "完了";
    // },
    textMessage() {
      return this.message;
    },

    showModal() {
      return this.show_modal;
    },
  },
  methods: {
    downloadExportFile(key){
      //FILE_EXPORT_PART2 : Step 18
      var open_file = this.$refs.open_file;
      open_file.click();
      var orig_msg = this.message;
      this.message = this.on_complete_message;
      this.spinVisable = false;
      setTimeout(()=>{
        //FILE_EXPORT_PART2 : Step 21
        this.message = orig_msg;
        this.closed()
      },2000)
    },
    checkExportFile(key){
      //FILE_EXPORT_PART2 : Step 11
      this.$ajax.post("/print_proxy/check/" + key, {}, (err, data) => {
        var status = data.status;
        //FILE_EXPORT_PART2 : Step 17
        if(status == "finished"){
          this.downloadExportFile(key)
        }else{
          setTimeout(()=>{
            this.checkExportFile(key);
          },1000)
        }
      });
    },
    initExportFile(){
      //FILE_EXPORT_PART2 : Step 3
      this.spinVisable = true;
      var opt = {
        filter: this.filter,
        sort: this.sort
      };
      if(this.sub_search){
        opt.sub_search = this.sub_search;
      }
      if(this.api_request_options){
        opt.api_request_options = this.api_request_options;
      }
      this.$ajax.post(this.url, opt, (err, data) => {
        if(err){
            this.$notify({
              title: 'データの出力に失敗しました。', 
              text: err,
              type: 'error',
              duration: 10000
            });
          }else{
            var key = data.print_key;
            this.linkToOpen = "/api/print_proxy/download/" + key;
            setTimeout(()=>{
              //FILE_EXPORT_PART2 : Step 10
              this.checkExportFile(key);
            },1000)
          }

      });
    },
    showModalWindow(data) {
      debug_msg("data", data);
      this.title_label = data.title;
      this.message = data.message;
      this.on_complete_message = data.on_complete_message || data.message;
      this.filter = data.filter;
      this.sort = data.sort;
      this.url = data.url;
      this.show_modal = true;
      if(data.api_request_options){
        this.api_request_options = data.api_request_options
      }
      if(data.sub_search){
        this.sub_search = data.sub_search
      }
      
      this.initExportFile()
    },
    closed(mode) {
      this.$emit("close",{})
      this.show_modal = false;
    }
  },
  props: {
    tag: { type: String, default: "runDownloadModal" },
  },
  mounted() {
    bus.$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy() {
    bus.$off(this.$props.tag);
  },
};
</script>
<style scoped>
.file-download-modal-body {
  height: 250px;
  overflow-y: auto;
}

.info_div {
  width: 32%;
  float: left;
}

.esma_td2 {
  margin: 2px 0px;
  border: 0px solid #bdbdbd;

  font-size: 11px;
  font-weight: 500;
  padding: 4px 0px 4px 4px;
}

.esma_td_h2 {
  margin: 2px 0px;
  _border: 1px solid #bdbdbd;
  _background-color: #b4d5f1;
  padding: 4px 8px;
  font-size: 11px;
  _font-weight: 900;
}
.fa-spin-custom,
.glyphicon-spin {
  -webkit-animation: spin 2000ms infinite linear;
  animation: spin 2000ms infinite linear;
}
</style>



// WEBPACK FOOTER //
// file-download-modal.vue?50a5269c